import '../css/index.scss';
import {get} from 'lodash';
import './switches';
import UScopeViewer from './_uScope';
import {PluginService} from './lib/services/plugin-service';
import {EventChannel} from 'shared/services/EventChannel';

const publicApi = {};

// This factory method creates and starts a uScope instance
publicApi.createUScope = function (settings) {
  const images = get(settings, 'images', []);

  const uScope = new UScopeViewer(publicApi.events);

  uScope.init(settings);

  publicApi.events.trigger('lbs.uscope:start', uScope);

  if (images.length > 0) {
    uScope.imageUpdate('add', settings.images);
  }

  return uScope;
};

// Add a global event channel
publicApi.events = new EventChannel();

// Create and expose the plugin service
const plugins = new PluginService(publicApi.events);
publicApi.plugins = plugins;
// I feel like injecting the plugin service onto the uScope instance is a bit hacky. It's already in the global space...
Object.defineProperty(UScopeViewer.prototype, 'pluginService', {
  get () {
    return plugins;
  }
});

export default publicApi;



// WEBPACK FOOTER //
// ./src/uScope/js/public-api.js